import React from "react";
import { StyleSheet, Text, View, TouchableOpacity, ScrollView } from "react-native";
import Colours from "../utils/Colours";
import QuestionMark from "../icons/QuestionMark";
import IdeaLamp from "../icons/IdeaLamp";
import ThreeDots from "../icons/threeDots";

const TutorialTables = ({ onProceed, onCancel }) => {
  const messages = [
    "Set up your weekends with Meeza Tables.",
    "Create a table and fund it via Meeza credits.",
    "Spend it via table reservations or simple money transfers.",
    "Money transfers from tables are available 24 hours after Meeza Tables have been created.",
    "Choose when your table will show up on the Doings trend.",
    "Share photos of fun moments on your table.",
    "All table values remain private, except for tables worth ₦50,000 or ₦100,000 and above, which are visible to the public.",
  ];

  return (
    <View style={styles.modalOverlay}>
      <View style={styles.modalContainer}>
        <QuestionMark height={40} width={40} color={"red"} />

        {/* Title */}
        <Text style={styles.noticeTitle}>Meeza Tables 101</Text>
        {/* <Text style={styles.noticeTitle2}>Social-Fitness is as important as Physical-Fitness, go out and have fun.</Text> */}
        <Text style={styles.noticeTitle2}>
          Share your celebrations, hangouts, parties and best moments of leisure on Meeza Tables.
        </Text>

        {/* Scrollable messages */}
        <ScrollView showsVerticalScrollIndicator={true} style={styles.messageScroll}>
          {/* First message - centered, no dots */}
          <View style={styles.firstMessageContainer}>
            <Text style={styles.firstMessageText}>{messages[0]}</Text>
          </View>

          {/* Remaining messages with ThreeDots */}
          {messages.slice(1).map((msg, index) => (
            <View key={index} style={styles.messageRow}>
              <ThreeDots color={Colours.PRIMARY} width={14} height={14} />
              <Text style={styles.noticeMessage}>{msg}</Text>
            </View>
          ))}
        </ScrollView>

        {/* Buttons */}
        <View style={styles.buttonContainer}>
          <TouchableOpacity style={styles.closeButton} onPress={onProceed}>
            <Text style={styles.closeButtonText}>Seen</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.cancelButton} onPress={onCancel}>
            <Text style={styles.closeButtonText}>Noted</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default TutorialTables;

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalContainer: {
    width: "90%",
    padding: 20,
    backgroundColor: "#fff",
    borderRadius: 10,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    maxHeight: "85%",
  },
  noticeTitle: {
    fontSize: 22,
    fontWeight: "bold",
    color: Colours.PRIMARY,
    textAlign: "center",
    marginTop: 10,
    fontFamily: "Sen-Bold",
  },
  noticeTitle2: {
    fontSize: 12,
    // fontWeight: 'bold',
    color: Colours.PRIMARY,
    textAlign: "center",
    marginBottom: 10,
    fontFamily: "Sen-Regular",
  },
  messageScroll: {
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
  },
  firstMessageContainer: {
    alignItems: "center",
    marginBottom: 15,
  },
  firstMessageText: {
    fontSize: 16,
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
    textAlign: "center",
    lineHeight: 24,
  },
  messageRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 10,
    gap: 8,
  },
  noticeMessage: {
    flex: 1,
    fontSize: 16,
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
    lineHeight: 22,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: 10,
  },
  closeButton: {
    backgroundColor: Colours.PRIMARY,
    paddingVertical: 10,
    borderRadius: 10,
    flex: 1,
    alignItems: "center",
    marginRight: 10,
  },
  cancelButton: {
    backgroundColor: Colours.DARKLIGHTGRAY,
    paddingVertical: 10,
    borderRadius: 10,
    flex: 1,
    alignItems: "center",
  },
  closeButtonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: 15,
    fontFamily: "Sen-Regular",
  },
});
